import { render, staticRenderFns } from "./GeralUsuarioComponent.vue?vue&type=template&id=70fd6cd5&scoped=true&"
import script from "./GeralUsuarioComponent.vue?vue&type=script&lang=js&"
export * from "./GeralUsuarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fd6cd5",
  null
  
)

export default component.exports